// React Basic and Bootstrap
import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';

//Import Components
import ReviewSlider2 from "../../components/Shared/review-slider2";

//Import Images
import client1 from "../../images/app-store.svg";
import client2 from "../../images/google-play.svg";

class Testi extends Component {
    render() {
        return (
            <React.Fragment>
                <section className="section pt-0" id="contact">
                    <Container>
                        {/* <Row>
                            <Col xs="12">
                                review-slider
                                <ReviewSlider2 clients={this.state.clients} />
                            </Col>
                        </Row> */}

                        <Row className="mt-md-5 pt-md-3 mt-4 pt-2 mt-sm-0 pt-sm-0 justify-content-center">
                            <Col xs="12" className="text-center">
                                <div className="section-title join-us">
                                    <h4 className="title mb-4">Únete!</h4>
                                    <div className="mt-2">
                                        <Link to="#" className="btn mt-2">
                                            <img src={client1} className="img-fluid" alt="" />
                                        </Link>
                                        <Link to="#" className="btn mt-2">
                                            <img src={client2} className="img-fluid" alt="" />
                                        </Link>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>
            </React.Fragment>
        );
    }
}
export default Testi;
